import React, { useState, useEffect, useMemo } from "react";
import { motion } from "framer-motion";
import throttle from "lodash.throttle";
import styles from "./TextWave.module.css";

const TextWave = ({ loaded, scrollWrapperRef }) => {
    const text = "Jakub Vychodil Art";
    const words = text.split(" ");
    const [scrollAmount, setScrollAmount] = useState(0);
    const [vwToPx, setVwToPx] = useState(window.innerWidth / 100);

    const initialXValues = useMemo(() => [
        0, 1.7936, 4.7744, 9.7424, 16.6976, 25.64, 36.5696, 49.4864
    ].map(val => val * vwToPx), [vwToPx]);

    const xTransition = loaded
        ? { delay: 0, duration: 0.2, ease: "easeOut" }
        : { delay: 0.5, duration: 0.8, ease: "easeInOut" };

    const offsetXValues = useMemo(() => {
        const maxCharIndex = 8;
        return Array.from({ length: maxCharIndex }, (_, i) => {
            return scrollAmount * (i * i) * vwToPx;
        });
    }, [scrollAmount, vwToPx]);

    useEffect(() => {
        const handleResize = () => {
            setVwToPx(window.innerWidth / 100);
        };

        const handleScroll = throttle(() => {
            const scrollTop = scrollWrapperRef?.current?.scrollTop ?? window.scrollY;
            setScrollAmount(scrollTop * 0.002);
        }, 50); // sníženo na 50 ms → plynulejší než 100, ale úspornější než 25

        window.addEventListener("resize", handleResize);

        const scrollEl = scrollWrapperRef?.current || window;
        scrollEl.addEventListener("scroll", handleScroll, { passive: true });

        return () => {
            window.removeEventListener("resize", handleResize);
            scrollEl.removeEventListener("scroll", handleScroll);
            handleScroll.cancel(); // důležité: zruší throttle při odmountování
        };
    }, [scrollWrapperRef]);

    return (
        <div className={`${styles.textWaveContainer} ${loaded ? styles.loaded : ""}`}>
            <div className={styles.textWave}>
                {words.map((word, wordIndex) => (
                    <div className={styles.word} key={`word-${wordIndex}`}>
                        {word.split("").map((char, charIndex) => {
                            const initialX = initialXValues[charIndex] ?? 0;
                            return (
                                <motion.span
                                    key={`char-${wordIndex}-${charIndex}`}
                                    className={styles.letter}
                                    initial={{ opacity: 0, x: initialX }}
                                    animate={{ opacity: 1, x: offsetXValues[charIndex] }}
                                    transition={{
                                        opacity: {
                                            delay: charIndex * 0.02,
                                            duration: 0.3,
                                            ease: "easeOut"
                                        },
                                        x: xTransition
                                    }}
                                >
                                    {char}
                                </motion.span>
                            );
                        })}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default TextWave;
